import React from "react";
import FileDownload from "js-file-download";
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

// Fetch CalendarFilingReferenceDocument
export const fetchCalendarFilingReferenceDocument = async (filingId) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
    );

    // console.log("fetchCalendarEventDetails res", res);
    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Download CalendarFilingReferenceDocument
export const downloadCalendarFilingReferenceDocument = async (
  attachmentId,
  filingId,
  fileName
) => {
  try {
    axios({
      url: `${API_BASE_URL}/Application/DownloadAttachment?AttachmentId=${attachmentId}&FilingId=${filingId}`,
      method: "POST",
      responseType: "blob", // Important
    }).then((response) => {
      FileDownload(response.data, fileName);
    });
    return;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};
